<div mat-dialog-title>Portfolios<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
    <div><irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'280px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [noRowsOverlayComponent]="'customNoRowOverlay'"
        [noRowsOverlayComponentParams]="loadingOverlayComponentParams"
        (gridReady) = "onGridReady($event)"
        [footerContent]="footerContent"></irb-inventory-grid></div> 
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>
